import { ARTIST_NAME, ARTIST_TAGLINE } from "./siteData";

export const Nav = () => (
  <nav
    data-testid="main-nav"
    className="sticky top-0 z-50 backdrop-blur-md bg-[#090a0f]/80 border-b border-[#212638] px-6 py-4"
  >
    <div className="max-w-6xl mx-auto flex items-center justify-between">
      <a href="#top" data-testid="nav-brand" className="flex items-center gap-3">
        <svg className="w-7 h-7 text-[#6366f1]" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" />
          <path d="M10 16h3l3-7 4 14 3-7h3" stroke="#818cf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="leading-none">
          <span className="font-disp font-bold tracking-tight text-sm uppercase text-white block">{ARTIST_NAME}</span>
          <span className="block text-[10px] text-[#818cf8] font-mono-code tracking-widest mt-0.5">{ARTIST_TAGLINE}</span>
        </span>
      </a>
      <div className="flex items-center gap-6">
        <a href="#portfolio" data-testid="nav-link-opere" className="hidden sm:inline text-xs font-mono-code text-[#94a3b8] hover:text-white transition-colors">
          OPERE
        </a>
        <a href="#sound-design" data-testid="nav-link-metodo" className="hidden sm:inline text-xs font-mono-code text-[#94a3b8] hover:text-white transition-colors">
          METODO
        </a>
        <a
          href="#contact"
          data-testid="nav-cta-commissiona"
          className="text-xs font-mono-code bg-[#4f46e5] text-white px-4 py-2 rounded-full hover:bg-[#4338ca] transition-colors"
        >
          COMMISSIONA
        </a>
      </div>
    </div>
  </nav>
);
